<mono-common-header
  [language]="language"
  [signInLinkPath]="signInLinkPath"
  [registrationLinkPath]="registrationLinkPath"
  [editMyDetailsLinkPath]="editMyDetailsLinkPath"
  [burgerMenuText]="
    (headerCms | async)?.data?.attributes?.menu
  "
  [ariaLabelMainNav]="
    (headerCms | async)?.data?.attributes?.ariaLabels.ariaLabelMainNav
  "
  [ariaLabelMobileNav]="
    (headerCms | async)?.data?.attributes?.ariaLabels.ariaLabelMobileNav
  "
  [ariaLabelBurgerButtonShow]="
    (headerCms | async)?.data?.attributes?.ariaLabels.ariaLabelBurgerButtonShow
  "
  [ariaLabelBurgerButtonHide]="
    (headerCms | async)?.data?.attributes?.ariaLabels.ariaLabelBurgerButtonHide
  "
  [hideUserLinks]="hideUserLinks"
>
  <ng-container headerLogo>
    <mono-common-header-logo
      logoSrc="assets/images/learn-my-way-logo.png"
      homePageAltText="Learn My Way logo"
      nonHomePageAltText="Link to the Learn My Way homepage"
    >
    </mono-common-header-logo>
  </ng-container>
  <ng-container mainNavigation>
    <li>
      <a
        *ngIf="currentRoute !== ''; else homeActive"
        rel="home"
        routerLink="/"
        >{{ (headerCms | async)?.data?.attributes?.home }}
      </a>
      <ng-template #homeActive
        ><span class="active" aria-selected="true">{{
          (headerCms | async)?.data?.attributes?.home
        }}</span></ng-template
      >
    </li>
    <li>
      <a
        *ngIf="
          currentRoute !== '/' + browseAllSubjectsLink;
          else subjectsActive
        "
        [routerLink]="['/', browseAllSubjectsLink]"
        >{{ (headerCms | async)?.data?.attributes?.subjects }}</a
      >
      <ng-template #subjectsActive
        ><span class="active" aria-selected="true">{{
          (headerCms | async)?.data?.attributes?.subjects
        }}</span></ng-template
      >
    </li>
    <li>
        <a
          *ngIf="currentRoute !== '/' + myLearningLink; else myLearningActive"
          [routerLink]="['/', myLearningLink]"
          >{{ (headerCms | async)?.data?.attributes?.myLearning }}</a
        >
      <ng-template #myLearningActive
        ><span class="active" aria-selected="true">{{ (headerCms | async)?.data?.attributes?.myLearning }}</span></ng-template
      >
    </li>
  </ng-container>
  <ng-container extraNavigation>
    <mono-common-header-help
      [helpText]="(headerCms | async)?.data?.attributes?.help"
      [helpLink]="helpLink"
      [currentRoute]="currentRoute"
    ></mono-common-header-help>
    <mono-common-header-search></mono-common-header-search>
  </ng-container>
</mono-common-header>
